import { memo } from 'react'

const Logo = memo(() => (
  <img
    src="/img/logo-compact-white.png"
    alt="CarbonSpace logo"
    className="cst-nav-bar-logo"
  />
))

export default Logo
